import {
  FullUser,
  OrderItems,
  ShiftsFragment,
  ShopperSessionFragment,
  WhenIWorkLogin,
} from './fragment';

import {gql} from '@apollo/client';

export const SEND_SMS_CODE = gql`
  mutation sendSMSCode($phoneNumber: String!) {
    sendSMSCode(phoneNumber: $phoneNumber) {
      code
    }
  }
`;

export const VERIFY_SMS_CODE = gql`
  mutation verifySMSCode($phoneNumber: String!, $code: String!) {
    verifySMSCode(phoneNumber: $phoneNumber, code: $code) {
      loginToken
      createUserToken
    }
  }
`;

export const REGISTER_SHOPPER = gql`
  mutation CreateUser(
    $createUserToken: String!
    $phoneNumber: String!
    $email: String!
    $firstName: String!
    $lastName: String!
    $invitationLink: String
    $facebookId: String
    $profileImage: String
    $referrerId: Int
    $userTypes: [UserType]
  ) {
    createUser(
      createUserToken: $createUserToken
      phoneNumber: $phoneNumber
      email: $email
      firstName: $firstName
      lastName: $lastName
      invitationLink: $invitationLink
      facebookId: $facebookId
      profileImage: $profileImage
      referrerId: $referrerId
      userTypes: $userTypes
    ) {
      loginToken
      user {
        ...FullUser
      }
    }
  }
  ${FullUser}
`;

export const Set_User_Attendance_Status = gql`
  mutation setUserAttendanceStatus($status: AttendanceStatus) {
    setUserAttendanceStatus(status: $status) {
      id
      userId
      status
      shiftId
    }
  }
`;

export const REGISTER_DEVICE_FOR_NOTIFICATIONS = gql`
  mutation RegisterDeviceForNotifications(
    $uuid: String!
    $pushToken: String!
    $platform: String
  ) {
    registerDeviceForNotifications(
      uuid: $uuid
      pushToken: $pushToken
      platform: $platform
    ) {
      id
      disabled
    }
  }
`;

export const UPDATE_NOTIFICATION_STATUS = gql`
  mutation updateNotificationStatus(
    $status: NotificationStatus
    $notificationId: Int
  ) {
    updateNotificationStatus(status: $status, notificationId: $notificationId)
  }
`;

export const WHEN_I_WORK_LOGIN = gql`
  mutation whenIWorkLogin($credential: WhenIWorkCredential) {
    whenIWorkLogin(credential: $credential) {
      ...WhenIWorkLogin
    }
  }
  ${WhenIWorkLogin}
`;

export const LOGOUT = gql`
  mutation Logout($deviceUuid: String) {
    logout(deviceUuid: $deviceUuid)
  }
`;

export const UPLOAD_RUN_RECEIPT = gql`
  mutation uploadRunReceipt(
    $runId: Int
    $clientUploadInfo: ClientFileUpload
    $uploadBy: UploadBy
  ) {
    uploadRunReceipt(
      runId: $runId
      clientUploadInfo: $clientUploadInfo
      uploadBy: $uploadBy
    ) {
      id
      fileName
      fileUrl
    }
  }
`;

export const DELETE_DELIVERY_IMAGE = gql`
  mutation deleteRunreceipt($runId: Int, $receiptUrl: String) {
    deleteRunreceipt(runId: $runId, receiptUrl: $receiptUrl)
  }
`;
export const UPDATE_SHOPPER_SESSION_STATUS = gql`
  mutation updateShopperSessionStatus(
    $sessionId: Int
    $status: ShopperSessionStatus
    $shiftId: String
    $latitude: Float
    $longitude: Float
  ) {
    updateShopperSessionStatus(
      sessionId: $sessionId
      status: $status
      shiftId: $shiftId
      latitude: $latitude
      longitude: $longitude
    ) {
      ...ShopperSessionFragment
    }
  }
  ${ShopperSessionFragment}
`;

export const UPDATE_USER_CHOICE_MAP = gql`
  mutation updateUserChoiceMap($mapChoice: MapChoice) {
    updateUserChoiceMap(mapChoice: $mapChoice)
  }
`;

export const TAKE_SHIFT = gql`
  mutation takeShift($shiftId: ID) {
    takeShift(shiftId: $shiftId) {
      availableShift {
        days {
          key
          shifts {
            ...ShiftsFragment
          }
        }
      }
    }
  }
  ${ShiftsFragment}
`;

export const ADD_NOTE_FOR_ORDER_ITEM = gql`
  mutation addNoteForOrderItem($orderItemId: Int, $note: String) {
    addNoteForOrderItem(orderItemId: $orderItemId, note: $note) {
      note
    }
  }
`;

export const UPDATE_ORDER_ITEM_STATUS = gql`
  mutation updateOrderItemStatus(
    $orderItemStatus: OrderItemStatus
    $orderItemIds: [Int]
    $dropItemMessage: String
    $isAdjacentOosItem: Boolean
    $runId: Int
    $actualUpcs: [String]
  ) {
    updateOrderItemStatus(
      orderItemStatus: $orderItemStatus
      orderItemIds: $orderItemIds
      dropItemMessage: $dropItemMessage
      isAdjacentOOSItem: $isAdjacentOosItem
      runId: $runId
      actualUpcs: $actualUpcs
    ) {
      ...OrderItems
    }
  }
  ${OrderItems}
`;

export const SET_DELIVERY_LOCATION_STATUS_ORDERS = gql`
  mutation setDeliveryLocationStatusOfAssignedOrders(
    $runId: Int
    $status: DeliveryLocationStatus
    $orderIds: [Int]
    $userType: UserType
    $skipPacking: Boolean
  ) {
    setDeliveryLocationStatusOfAssignedOrders(
      runId: $runId
      status: $status
      orderIds: $orderIds
      userType: $userType
      skipPacking: $skipPacking
    ) {
      id
      deliveryStatus
    }
  }
`;

export const GET_ORDER_ASSIGNEE = gql`
  mutation countForOrdersAssignedToDriver($runId: Int) {
    countForOrdersAssignedToDriver(runId: $runId)
  }
`;

export const SEND_SUBSTITUTION_REQUEST_TO_BUYER = gql`
  mutation sendRequestToBuyer(
    $orderItemId: Int!
    $menuItemId: Int
    $catalogItemId: Int
    $quantity: Int
    $menuOptionIds: [Int!]
    $itemIndex: Int
    $itemSource: String
  ) {
    sendRequestToBuyer(
      orderItemId: $orderItemId
      menuItemId: $menuItemId
      catalogItemId: $catalogItemId
      quantity: $quantity
      menuOptionIds: $menuOptionIds
      itemIndex: $itemIndex
      itemSource: $itemSource
    ) {
      id
    }
  }
`;
export const ADD_ITEM_REMARK = gql`
  mutation addItemRemark($orderItemId: Int, $itemRemark: String) {
    addItemRemark(orderItemId: $orderItemId, itemRemark: $itemRemark)
  }
`;

export const SUBSTITUTE_ITEM_IN_RUN = gql`
  mutation substituteItemInRun(
    $orderId: Int!
    $orderItemId: Int!
    $priceWithTax: Int
    $name: String!
    $itemImageUrl: String
    $options: String
    $position: Int!
    $menuItemId: Int
    $catalogItemId: Int
    $menuOptionGroupId: Int
    $menuOptionId: [Int]
    $price: Int!
    $quantity: Int!
    $tags: String
    $isCustomItem: Boolean!
    $substitutedBy: String!
    $substitutionItemId: Int
    $substitutionRequestParmas: ItemSubstitutionRequestParamas
    $itemIndex: Int
    $itemSource: String
    $isPriceSensitive: Boolean
    $isWeightSensitive: Boolean
    $metaLoggingForKpi: JSON
    $upcInput: B2BItemUPCInput
    $runId: Int
  ) {
    substituteItemInRun(
      orderId: $orderId
      orderItemId: $orderItemId
      name: $name
      itemImageUrl: $itemImageUrl
      options: $options
      position: $position
      menuItemId: $menuItemId
      catalogItemId: $catalogItemId
      menuOptionGroupId: $menuOptionGroupId
      menuOptionId: $menuOptionId
      price: $price
      priceWithTax: $priceWithTax
      quantity: $quantity
      tags: $tags
      isCustomItem: $isCustomItem
      substitutedBy: $substitutedBy
      substitutionItemId: $substitutionItemId
      substitutionRequestParmas: $substitutionRequestParmas
      itemIndex: $itemIndex
      itemSource: $itemSource
      isPriceSensitive: $isPriceSensitive
      isWeightSensitive: $isWeightSensitive
      metaLoggingForKpi: $metaLoggingForKpi
      upcInput: $upcInput
      runId: $runId
    ) {
      id
    }
  }
`;

export const SCAN_UPC_FOR_ALL_ITEMS = gql`
  mutation scanUPCForAllItems(
    $upc: String
    $catalogItemId: Int!
    $storeIndex: String!
    $runId: Int
    $lon: Float
    $lat: Float
    $isAdjacentOOSItem: Boolean
    $conversationId: String
    $orderItemIds: [Int]
  ) {
    scanUPCForAllItems(
      upc: $upc
      catalogItemId: $catalogItemId
      storeIndex: $storeIndex
      runId: $runId
      lon: $lon
      lat: $lat
      isAdjacentOOSItem: $isAdjacentOOSItem
      conversationId: $conversationId
      orderItemIds: $orderItemIds
    ) {
      message
      scanned
      catalogItemId
    }
  }
`;

export const SCAN_UPC_FOR_ALL_ITEMS_IMAGES = gql`
  mutation scanUPCForAllItems(
    $images: [String]
    $catalogItemId: Int!
    $storeIndex: String!
    $runId: Int
    $lon: Float
    $lat: Float
    $isAdjacentOOSItem: Boolean
    $conversationId: String
    $orderItemIds: [Int]
  ) {
    scanUPCForAllItems(
      images: $images
      catalogItemId: $catalogItemId
      storeIndex: $storeIndex
      runId: $runId
      lon: $lon
      lat: $lat
      isAdjacentOOSItem: $isAdjacentOOSItem
      conversationId: $conversationId
      orderItemIds: $orderItemIds
    ) {
      message
      scanned
    }
  }
`;

export const ADJACENT_OOS_ITEM_FOUND = gql`
  mutation AdjacentOOSItemFound(
    $version: APIV1Version!
    $requestParams: AdjacentOOSItemFoundArgs
  ) {
    adjacentOOSItemFound(version: $version, requestParams: $requestParams) {
      data {
        V100 {
          adjacentOOSItem {
            foundAt
            id
            itemStatus
            newRunId
            newShopperId
            orderId
            runId
          }
        }
      }
    }
  }
`;

export const UPDATE_ITEMS_PRICE = gql`
  mutation updateItemsPrice($orderItemId: Int, $price: Int, $runId: Int) {
    updateItemsPrice(orderItemId: $orderItemId, price: $price, runId: $runId)
  }
`;

export const DELETE_RUN_RECEIPT = gql`
  mutation deleteRunreceipt($runId: Int, $receiptUrl: String) {
    deleteRunreceipt(runId: $runId, receiptUrl: $receiptUrl)
  }
`;

export const UPLOAD_UPC_IMAGE = gql`
  mutation uploadUpcImages(
    $storeIndex: String!
    $orderItemId: Int
    $file: Upload
  ) {
    uploadUpcImages(
      storeIndex: $storeIndex
      orderItemId: $orderItemId
      file: $file
    )
  }
`;

export const ADD_ITEM = gql`
  mutation addItemInRun(
    $orderId: Int!
    $priceWithTax: Int
    $name: String!
    $itemImageUrl: String
    $options: String
    $position: Int!
    $menuItemId: Int
    $catalogItemId: Int
    $menuOptionGroupId: Int
    $menuOptionId: [Int]
    $price: Int!
    $quantity: Int!
    $tags: String
    $isCustomItem: Boolean!
    $itemUnit: String
    $source: String
    $priceSensitive: Boolean!
    $weightSensitive: Boolean!
    $runId: Int
    $upcCodes: [String]
    $upcOriginal: String
  ) {
    addItemInRun(
      orderId: $orderId
      name: $name
      itemImageUrl: $itemImageUrl
      options: $options
      position: $position
      menuItemId: $menuItemId
      catalogItemId: $catalogItemId
      menuOptionGroupId: $menuOptionGroupId
      menuOptionId: $menuOptionId
      price: $price
      priceWithTax: $priceWithTax
      quantity: $quantity
      tags: $tags
      isCustomItem: $isCustomItem
      itemUnit: $itemUnit
      source: $source
      priceSensitive: $priceSensitive
      weightSensitive: $weightSensitive
      runId: $runId
      upcCodes: $upcCodes
      upcOriginal: $upcOriginal
    ) {
      id
    }
  }
`;

export const SET_SUBSTITUTION_STATUS = gql`
  mutation setRequestStatus(
    $requestIds: [Int!]
    $status: SubstitutionRequestStatus!
    $runId: Int
    $navigateToScreen: String
  ) {
    setRequestStatus(
      requestIds: $requestIds
      status: $status
      runId: $runId
      navigateToScreen: $navigateToScreen
    ) {
      id
    }
  }
`;

export const CONNECT_STRIPE_ACCOUNT = gql`
  mutation connectRunnerStripeAccount($code: String!) {
    connectRunnerStripeAccount(code: $code)
  }
`;

export const IS_ACCOUNT_DELETABLE = gql`
  mutation isUserDeletable {
    isUserDeletable {
      isDeletable
      header
      subtext
    }
  }
`;

export const SET_DELIVERY_LOCATION_STATUS = gql`
  mutation setDeliveryLocationStatus(
    $deliveryLocationId: Int!
    $status: DeliveryLocationStatus!
    $deliveryFailureReason: String
    $runId: Int
  ) {
    setDeliveryLocationStatus(
      deliveryLocationId: $deliveryLocationId
      status: $status
      deliveryFailureReason: $deliveryFailureReason
      runId: $runId
    ) {
      id
      runId
      deliveryFailureReason
    }
  }
`;

export const DELETE_ACCOUNT = gql`
  mutation deleteCurrentUser {
    deleteCurrentUser {
      isDeleted
      header
      subtext
    }
  }
`;

export const UPLOAD_DELIVERY_IMAGE = gql`
  mutation uploadDeliveryImage(
    $orderId: Int
    $file: Upload
    $deliveryImageType: DeliveryImageType
    $runId: Int
  ) {
    uploadDeliveryImage(
      orderId: $orderId
      file: $file
      deliveryImageType: $deliveryImageType
      runId: $runId
    ) {
      uri
    }
  }
`;

export const ADD_NOTE_FOR_DELIVERY_LOCATION = gql`
  mutation addNoteForDeliveryLocation(
    $deliveryLocationId: Int
    $note: String
    $runId: Int
  ) {
    addNoteForDeliveryLocation(
      deliveryLocationId: $deliveryLocationId
      note: $note
      runId: $runId
    ) {
      note
    }
  }
`;

export const DELETE_DELIVERY_IMAGE_FOR_DRIVER = gql`
  mutation deleteDeliveryImage(
    $deliveryLocationId: Int
    $deliveryImageUrl: String
  ) {
    deleteDeliveryImage(
      deliveryLocationId: $deliveryLocationId
      deliveryImageUrl: $deliveryImageUrl
    )
  }
`;

export const UPLOAD_VAN_INSPECTION_IMAGE = gql`
  mutation uploadVanInspectionImages($file: Upload, $runId: Int) {
    uploadVanInspectionImages(file: $file, runId: $runId) {
      uri
    }
  }
`;

export const START_RUNNER_TUTORIAL = gql`
  mutation startTutorialForRunner($userType: UserType) {
    startTutorialForRunner(userType: $userType) {
      runId
      orderId
    }
  }
`;

export const FINISH_RUNNER_TUTORIAL = gql`
  mutation finishTutorialForRunner($name: TutorialNames) {
    finishTutorialForRunner(name: $name)
  }
`;

export const SET_ORDER_ASSIGNEE = gql`
  mutation setOrderAssignee(
    $authorId: Int!
    $orderIds: [Int!]
    $runId: Int!
    $link: String!
    $assignTo: AssignTo
  ) {
    setOrderAssignee(
      authorId: $authorId
      orderIds: $orderIds
      runId: $runId
      link: $link
      assignTo: $assignTo
    ) {
      id
    }
  }
`;

export const MARK_MEMO_READ = gql`
  mutation markMemoAsRead($memoId: Int) {
    markMemoAsRead(memoId: $memoId)
  }
`;

export const UPLOAD_IMAGE = gql`
  mutation itemImageUpload($file: Upload) {
    itemImageUpload(file: $file) {
      uri
    }
  }
`;

export const COMPLETE_VAN_INSPECTION = gql`
  mutation completeVanInspection($startDate: String) {
    completeVanInspection(startDate: $startDate)
  }
`;

export const UPDATE_ITEM_IMAGE = gql`
  mutation updateCustomItemImage($itemImageUrl: String, $orderItemId: Int) {
    updateCustomItemImage(
      itemImageUrl: $itemImageUrl
      orderItemId: $orderItemId
    )
  }
`;

export const UPDATE_SHOPPER_ITEM_CHANGES = gql`
  mutation updateShopperItemChanges(
    $shopperItemChanges: [ShopperItemChanges]
    $isAdjacentOosItem: Boolean
    $isB2BFlow: Boolean
  ) {
    updateShopperItemChanges(
      shopperItemChanges: $shopperItemChanges
      isAdjacentOOSItem: $isAdjacentOosItem
      isB2BFlow: $isB2BFlow
    )
  }
`;

// UPC Shift APIs

export const CREATE_UPC_SHIFT = gql`
  mutation createUpcOrder(
    $storeName: String
    $storeLogo: String
    $esIndex: String
    $noOfOrderItems: Int
  ) {
    createUpcOrder(
      storeName: $storeName
      storeLogo: $storeLogo
      esIndex: $esIndex
      noOfOrderItems: $noOfOrderItems
    ) {
      created
      message
      upcOrder {
        id
        storeName
        storeLogo
        esIndex
        shopperId
        orderStatus
      }
    }
  }
`;

export const SUBMIT_STARTING_BAG_COUNT = gql`
  mutation submitStartingBagCount($runBagCount: RunBagCount) {
    submitStartingBagCount(runBagCount: $runBagCount) {
      id
      bagsCount
    }
  }
`;

export const SCAN_UPC = gql`
  mutation scanUPC(
    $upc: String
    $images: [String]
    $catalogItemId: Int!
    $storeIndex: String!
    $orderItemId: Int
    $lon: Float
    $lat: Float
    $isUpcOrder: Boolean = false
  ) {
    scanUPC(
      upc: $upc
      images: $images
      catalogItemId: $catalogItemId
      storeIndex: $storeIndex
      orderItemId: $orderItemId
      lon: $lon
      lat: $lat
      isUpcOrder: $isUpcOrder
    ) {
      message
      orderItem {
        id
      }
    }
  }
`;

export const DROP_UPC_ITEMS = gql`
  mutation dropUpcOrderItem($upcOrderItemId: Int!) {
    dropUpcOrderItem(upcOrderItemId: $upcOrderItemId)
  }
`;

export const CAPTURE_ITEM_INFORMATION = gql`
  mutation captureItemInformation(
    $isUpcOrder: Boolean
    $orderItemId: Int
    $aisle: String
    $storeContext: String
    $locationImage: String
    $price: Int
    $esIndex: String!
  ) {
    captureItemInformation(
      isUpcOrder: $isUpcOrder
      orderItemId: $orderItemId
      aisle: $aisle
      storeContext: $storeContext
      locationImage: $locationImage
      price: $price
      esIndex: $esIndex
    ) {
      id
    }
  }
`;

export const ADD_SUBSTITUTE_FOR_UPC = gql`
  mutation addSubstitutionSuggestion(
    $upcOrderItemId: Int
    $catalogItemId: Int
    $name: String
    $price: Int
    $isCustomItem: Boolean
    $itemImageUrl: String
    $note: String
  ) {
    addSubstitutionSuggestion(
      upcOrderItemId: $upcOrderItemId
      catalogItemId: $catalogItemId
      name: $name
      price: $price
      isCustomItem: $isCustomItem
      itemImageUrl: $itemImageUrl
      note: $note
    ) {
      catalogItemId
    }
  }
`;

export const MARK_ITEM_AS_FOUND_OR_MISSING = gql`
  mutation markItemAsFoundOrMissing(
    $itemInfoId: Int!
    $foundHere: Boolean
    $reportMissing: Boolean
  ) {
    markItemAsFoundOrMissing(
      itemInfoId: $itemInfoId
      foundHere: $foundHere
      reportMissing: $reportMissing
    ) {
      aisle
      catalogItemId
      esIndex
      foundHere
      id
      itemForReplacement
      locationImage
      orderItemId
      price
      reportMissing
      storeContext
      upcOrderItemId
    }
  }
`;

export const UPDATE_UPC_ORDER_STATUS = gql`
  mutation updateUpcOrderStatus($upcOrderId: Int!, $status: UpcOrderStatus) {
    updateUpcOrderStatus(upcOrderId: $upcOrderId, status: $status)
  }
`;

export const SCAN_UPC_FOR_CROWD_SOURCE = gql`
  mutation ScanUPC(
    $catalogItemId: Int!
    $storeIndex: String!
    $upc: String
    $images: [String]
    $orderItemId: Int
    $lat: Float
    $lon: Float
    $isUpcOrder: Boolean
  ) {
    scanUPC(
      catalogItemId: $catalogItemId
      storeIndex: $storeIndex
      upc: $upc
      images: $images
      orderItemId: $orderItemId
      lat: $lat
      lon: $lon
      isUpcOrder: $isUpcOrder
    ) {
      message
      orderItem {
        id
      }
    }
  }
`;

export const SUBMIT_DELIVERY_BAGS_COUNT = gql`
  mutation submitDeliveryBagsCount(
    $runBagCount: RunBagCount
    $returnBagForOrder: ReturnedBagForOrder
  ) {
    submitDeliveryBagsCount(
      runBagCount: $runBagCount
      returnBagForOrder: $returnBagForOrder
    ) {
      id
      bagsCount
    }
  }
`;

export const UPDATE_ORDER_ITEM_QUANTITY = gql`
  mutation UpdateOrderItemQuantity(
    $orderItemId: Int
    $itemQuantity: Int
    $runId: Int
  ) {
    updateOrderItemQuantity(
      orderItemId: $orderItemId
      itemQuantity: $itemQuantity
      runId: $runId
    ) {
      id
      quantity
    }
  }
`;

export const UPLOAD_RUN_RECEIPT_OLD = gql`
  mutation uploadRunReceipt($runId: Int, $file: Upload) {
    uploadRunReceipt(runId: $runId, file: $file) {
      id
      fileName
      fileUrl
    }
  }
`;

export const GENERATE_BARCODES_DATA_FOR_ORDER = gql`
  mutation GenerateBarcodesDataForOrder($orderIds: [Int], $runId: Int) {
    generateBarcodesDataForOrder(orderIds: $orderIds, runId: $runId) {
      code
      createdAt
      id
      order {
        id
      }
      orderId
      position
      status
      generationType
    }
  }
`;

export const UPDATE_BARCODE_STATUS = gql`
  mutation UpdateBarcodeStatus(
    $code: String
    $status: BarcodeStatus
    $orderIds: [Int]
    $updateAll: Boolean
    $generationType: BarcodeGenerationType
    $runId: Int
  ) {
    updateBarcodeStatus(
      code: $code
      status: $status
      orderIds: $orderIds
      updateAll: $updateAll
      generationType: $generationType
      runId: $runId
    ) {
      code
      createdAt
      generationType
      id
      order {
        id
      }
      orderId
      position
      status
    }
  }
`;

export const GENERATE_BARCODES_FILE = gql`
  mutation GenerateBarcodesFile($orderIds: [Int], $b2bOrderIds: [Int]) {
    generateBarcodesFile(orderIds: $orderIds, b2bOrderIds: $b2bOrderIds) {
      barcodeData
      cmd {
        command
        density
        height
        offset
        sensor
        speed
        vertical
        width
      }
      cmdprint
    }
  }
`;

export const UPDATE_ORDER_ITEM_PROPERTIES = gql`
  mutation updateOrderItemProperties(
    $args: OrderPropertiesInput
    $catalogItemId: Int
    $orderItemId: Int
    $runId: Int
    $storeIndex: String
  ) {
    updateOrderItemProperties(
      args: $args
      catalogItemId: $catalogItemId
      orderItemId: $orderItemId
      runId: $runId
      storeIndex: $storeIndex
    )
  }
`;

export const UPDATE_PRICE_TAG_ORDER_ITEM_PROPERTIES = gql`
  mutation UpdateOrderItemProperties(
    $orderItemId: Int
    $args: OrderPropertiesInput
    $runId: Int
    $storeIndex: String
  ) {
    updateOrderItemProperties(
      orderItemId: $orderItemId
      args: $args
      runId: $runId
      storeIndex: $storeIndex
    )
  }
`;

export const READ_CONVERSATION = gql`
  mutation readConversation($conversationId: String) {
    readConversation(conversationId: $conversationId) {
      data {
        read
      }
    }
  }
`;

export const UPDATE_CATEGORY_BY_SHOPPER = gql`
  mutation updateCategoryByShopper(
    $storeIndex: String!
    $oldCategory: String!
    $catalogItemId: Int!
    $newCategory: String!
  ) {
    updateCategoryByShopper(
      storeIndex: $storeIndex
      oldCategory: $oldCategory
      catalogItemId: $catalogItemId
      newCategory: $newCategory
    )
  }
`;

export const UPDATE_ACCURACY_PERCENTAGE_FOR_UPC = gql`
  mutation UpdateAccuracyPercentageForUpc(
    $catalogItemId: Int
    $upc: String
    $storeIndex: String
  ) {
    updateAccuracyPercentageForUpc(
      catalogItemId: $catalogItemId
      upc: $upc
      storeIndex: $storeIndex
    )
  }
`;

export const ADD_B2B_ITEM = gql`
  mutation addB2BItemInRun(
    $orderId: Int!
    $name: String!
    $position: Int!
    $price: Int!
    $quantity: Int!
    $isCustomItem: Boolean!
    $itemImageUrl: String
    $catalogItemId: Int
    $tags: String
    $itemUnit: String
    $upcCodes: [String]
    $upcOriginal: String
    $runId: Int
  ) {
    addItemInRun(
      orderId: $orderId
      name: $name
      position: $position
      price: $price
      quantity: $quantity
      isCustomItem: $isCustomItem
      itemImageUrl: $itemImageUrl
      catalogItemId: $catalogItemId
      tags: $tags
      itemUnit: $itemUnit
      upcCodes: $upcCodes
      upcOriginal: $upcOriginal
      runId: $runId
    ) {
      id
    }
  }
`;

export const UPDATE_B2B_ORDER_VERIFY_STATUS = gql`
  mutation UpdateB2BOrderVerifyStatus(
    $version: APIV1Version!
    $requestParams: UpdateB2BOrderVerifyStatusArgs
  ) {
    updateB2BOrderVerifyStatus(
      version: $version
      requestParams: $requestParams
    ) {
      data {
        V100 {
          status
        }
      }
    }
  }
`;

export const UPDATE_NSC_ITEM_STATUS = gql`
  mutation updateNSCOrderItemStatus(
    $orderItemStatus: OrderItemStatus
    $orderItemId: Int
    $runId: Int
    $actualUpcs: [String]
  ) {
    updateOrderItemStatus(
      orderItemStatus: $orderItemStatus
      orderItemId: $orderItemId
      runId: $runId
      actualUpcs: $actualUpcs
    ) {
      id
      price
      quantity
      orderItemAttribute {
        units
        weight
      }
    }
  }
`;

export const ORDER_VALIDATION_UPDATE = gql`
  mutation OrderValidationUpdate(
    $version: APIV1Version
    $requestParams: OrderValidationArgs
  ) {
    OrderValidation(version: $version, requestParams: $requestParams) {
      data {
        V100 {
          orders {
            status
            order {
              id
              buyer {
                lastName
                firstName
              }
              items {
                id
                itemImageUrl
              }
            }
            defectedItems {
              itemImageUrl
              itemStatus
              id
              name
              quantity
            }
          }
        }
      }
    }
  }
`;

export const UPDATE_B2B_ORDER = gql`
  mutation UpdateB2BOrder(
    $version: APIV1Version!
    $requestParams: UpdateB2BOrderArgs
  ) {
    updateB2BOrder(version: $version, requestParams: $requestParams) {
      data {
        V100 {
          status
        }
      }
    }
  }
`;

export const CANCEL_ORDER = gql`
  mutation CancelOrder($orderId: Int!, $runId: Int) {
    cancelOrder(orderId: $orderId, runId: $runId) {
      id
    }
  }
`;

export const SET_ASSIGNE_TO_ORDER = gql`
  mutation setAssigneeToOrder(
    $orderIds: [Int]
    $shopper: Int!
    $driver: Int
    $inspectVan: Boolean
    $runId: Int
  ) {
    setAssigneeToOrder(
      orderIds: $orderIds
      shopper: $shopper
      driver: $driver
      inspectVan: $inspectVan
      runId: $runId
    ) {
      id
    }
  }
`;

export const CREATE_ONFLEET_TASK = gql`
  mutation createTaskOnOnfleet(
    $orderId: Int
    $runId: Int
    $isB2BFlow: Boolean
  ) {
    createTaskOnOnfleet(orderId: $orderId, runId: $runId, isB2BFlow: $isB2BFlow)
  }
`;

export const SET_RUN_STATUS = gql`
  mutation setRunStatus($runId: Int!, $runStatus: RunStatus!) {
    setRunStatus(runId: $runId, status: $runStatus) {
      id
    }
  }
`;
